import { useCallback } from 'react';
import {
  usePublicProfileData,
  useProfileTracking,
} from '@/context/PublicProfileContext';
import { sendLinkTap } from '@/utils/beacon';

export function useLinkTap(): (linkId: string) => void {
  const { profile } = usePublicProfileData();
  const tracking = useProfileTracking();
  const handle = profile.handle;

  return useCallback(
    (linkId: string) => {
      if (!tracking || !handle) return;
      sendLinkTap(handle, linkId);
    },
    [tracking, handle],
  );
}
